import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaSave, FaServer } from 'react-icons/fa';

const ManageMailSettingsPage = () => {
    const [formData, setFormData] = useState({
        host: 'tarna.urartech.com',
        port: 993,
        user: 'havuz@payda.web.tr',
        password: '' // Güvenlik için boş, admin girmeli
    });
    const [loading, setLoading] = useState(false);
    const [msg, setMsg] = useState(null);

    const API_URL = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api';

    // Mevcut ayarları çek (Sadece var mı yok mu kontrolü için)
    useEffect(() => {
        const fetchConfig = async () => {
            const token = localStorage.getItem('token').replace(/"/g, '');
            try {
                const { data } = await axios.get(`${API_URL}/mail/config`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                if(data.isConfigured) {
                    setFormData(prev => ({
                        ...prev,
                        host: data.host,
                        port: data.port,
                        user: data.user
                    }));
                }
            } catch (error) { console.error(error); }
        };
        fetchConfig();
    }, [API_URL]);

    const handleSave = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMsg(null);
        
        const token = localStorage.getItem('token').replace(/"/g, '');
        try {
            await axios.post(`${API_URL}/mail/config`, formData, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setMsg({ type: 'success', text: 'Ayarlar başarıyla kaydedildi.' });
        } catch (error) {
            setMsg({ type: 'error', text: 'Kaydedilemedi.' });
        }
        setLoading(false);
    };

    return (
        <div className="max-w-2xl mx-auto space-y-6">
            <h1 className="text-2xl font-bold text-white mb-6">Mail Sunucu Ayarları</h1>
            
            {msg && <div className={`p-4 rounded border ${msg.type === 'success' ? 'bg-green-900 border-green-500 text-green-300' : 'bg-red-900 border-red-500 text-red-300'}`}>{msg.text}</div>}

            <form onSubmit={handleSave} className="bg-surface p-6 rounded-xl border border-border shadow-lg space-y-4">
                <div className="flex items-center gap-2 text-primary mb-4 pb-2 border-b border-gray-700">
                    <FaServer />
                    <span className="font-bold">IMAP Bağlantı Bilgileri</span>
                </div>

                <div>
                    <label className="block text-xs font-bold text-text-secondary mb-1">Sunucu Adresi (Host)</label>
                    <input type="text" value={formData.host} onChange={e => setFormData({...formData, host: e.target.value})} className="w-full bg-background border border-border rounded p-2 text-white outline-none focus:border-primary" required />
                </div>

                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-xs font-bold text-text-secondary mb-1">Port (IMAP)</label>
                        <input type="number" value={formData.port} onChange={e => setFormData({...formData, port: e.target.value})} className="w-full bg-background border border-border rounded p-2 text-white outline-none focus:border-primary" required />
                    </div>
                    <div>
                        <label className="block text-xs font-bold text-text-secondary mb-1">Kullanıcı (E-Posta)</label>
                        <input type="email" value={formData.user} onChange={e => setFormData({...formData, user: e.target.value})} className="w-full bg-background border border-border rounded p-2 text-white outline-none focus:border-primary" required />
                    </div>
                </div>

                <div>
                    <label className="block text-xs font-bold text-text-secondary mb-1">Şifre</label>
                    <input type="password" value={formData.password} onChange={e => setFormData({...formData, password: e.target.value})} placeholder="Yeni şifre giriniz..." className="w-full bg-background border border-border rounded p-2 text-white outline-none focus:border-primary" />
                    <p className="text-[10px] text-gray-500 mt-1">* Şifreyi sadece değiştirmek istiyorsanız doldurun.</p>
                </div>

                <button type="submit" disabled={loading} className="w-full bg-primary hover:bg-blue-600 text-white py-3 rounded-lg font-bold transition-colors flex justify-center items-center gap-2">
                    <FaSave /> {loading ? 'Kaydediliyor...' : 'Ayarları Kaydet'}
                </button>
            </form>
        </div>
    );
};

export default ManageMailSettingsPage;